import React, { FunctionComponent } from 'react';
import NotFound from '../NotFound/NotFound';
import authService from '../../services/AuthService';
import { Roles } from '@beable/roster-backend-client-v1';
import Login from '../Login/Login';


interface ProtectedRouteProps {
    Component: FunctionComponent<any>;
}

export default function ProtectedRoute({ Component }: ProtectedRouteProps) {
    const user = authService.getUser();

    if ((!user) || (user?.sessionEnd && user.sessionEnd < new Date().getTime())) {
        authService.unsetUser();
        return (
            <Login />
        );
    }

    if ((user && user?.role !== Roles.beableadmin && window.location.pathname === '/manage') || !Component) {
        return (
            <NotFound />
        );
    }

    return (<Component {...user}/>);
}
